import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import './buttonGroup.css';

/*
#tailwind
*/

function ButtonGroup({ children, className, ...other }) {
  return (
    <div className={bem`buttonGroup ${className}`} {...other}>
      {children}
    </div>
  );
}

ButtonGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ButtonGroup.defaultProps = {
  children: undefined,
  className: undefined,
};

export default ButtonGroup;
